import { debounce } from 'lodash';
import { z } from 'zod';

import { trackEvent } from '@/utils/analytics';

/**
 * Validation and input-change tracking shared by sign-in and email confirmation
 */

export const isValidEmail = (email: string): boolean =>
  z.string().email().safeParse(email).success;

export const trackEmailUpdateEvent = debounce(
  (email: string) => trackEvent('LOGIN_EMAIL_ENTERED', { email }),
  1000
);

export const trackLoginCodeUpdateEvent = debounce(
  (email: string, code: string) =>
    trackEvent('LOGIN_CODE_ENTERED', { code, email }),
  1000
);

export const trackSniperLinkClicked = (email: string, provider: string) =>
  trackEvent('LOGIN_SNIPER_LINK_CLICKED', { email, provider });
